<h2 mat-dialog-title>Add Email Signature</h2>
<mat-dialog-content class="email-signature-dialog-content">

  <app-html-editor
    [formControl]="signatureContent"
    [placeholder]="'Type your signature here...'"
    [costumHeader]="true"
    [signature]="data.prevSignature"
    [height]="'300px'"
    [quillModule]="quillModule"
  ></app-html-editor>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-raised-button color="primary" (click)="saveSignature()">Save</button>
</mat-dialog-actions>
